export enum RouteNames {
  PluginDetails = 'PluginDetails',
  Plugins = 'Plugins',
}
